import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px',
        }}></div>
      </div>
      
      {/* Animated Gradient Orbs */}
      <div className="absolute top-1/4 left-1/4 w-48 h-48 sm:w-96 sm:h-96 bg-blue-500/30 rounded-full mix-blend-multiply filter blur-[64px] sm:blur-[128px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-48 h-48 sm:w-96 sm:h-96 bg-purple-500/30 rounded-full mix-blend-multiply filter blur-[64px] sm:blur-[128px] animate-pulse delay-1000"></div>

      {/* Content */}
      <div className="container mx-auto px-6 pt-24 relative z-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-start">
          {/* Left Content */}
          <div className="max-w-3xl">
            <motion.h1 
              className="text-4xl sm:text-6xl font-bold mb-6"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <motion.span 
                className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 block pb-2"
                variants={textVariants}
              >
                Your Trusted Enterprise
              </motion.span>
              <motion.span 
                className="text-white block"
                variants={textVariants}
              >
                Solutions Provider
              </motion.span>
            </motion.h1>
            
            <p className="text-lg sm:text-xl text-gray-300 mb-8 leading-relaxed">
              Specializing in high-end IT consulting, software solutions, hardware solutions, 
              and internet services for businesses worldwide. With strong presence in Sri Lanka and the UK.
            </p>
            
            <div className="flex gap-4 items-center">
              {/* Get Started Button */}
              <Link to="/services">
                <button className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 sm:px-8 py-3 sm:py-4 
                  rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300">
                  Get Started
                </button>
              </Link>

              {/* Learn More Button */}
              <Link to="/about">
                <button className="border-2 border-white/20 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg 
                  font-semibold hover:bg-white/10 transition-all duration-300 backdrop-blur-sm">
                  Learn More
                </button>
              </Link>
            </div>
          </div>

          {/* Right Content - Logo with 3D Effect */}
          <div className="relative w-full lg:w-1/2 flex justify-center mt-9 lg:mt-3">
            <div className="p-2 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 opacity-20">
              <img
                src="/logo.png"
                alt="Hither Tech Logo"
                className="w-64 lg:w-80 transform transition-transform duration-500 hover:scale-110 animate-spin-slow opacity-60 bg-white rounded-full"
                style={{
                  perspective: '1000px',
                  transformStyle: 'preserve-3d',
                }}
              />
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-8 mt-12">
          {[
            { number: '50+', label: 'Clients Worldwide' },
            { number: '50+', label: 'IT Experts' },
            { number: '100+', label: 'Projects Completed' },
            { number: '99%', label: 'Client Satisfaction' }
          ].map((stat, index) => (
            <div key={index} className="text-center backdrop-blur-sm p-4 rounded-lg 
              border border-white/10 hover:border-white/20 transition-colors">
              <div className="text-3xl font-bold bg-clip-text text-transparent 
                bg-gradient-to-r from-blue-400 to-purple-400">
                {stat.number}
              </div>
              <div className="text-gray-400 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;